export const JOIN_ROOM = (conversationId: string) => `conversation_${conversationId}_room`;
export const CONVERSATION_CHAT_ADDED = (conversationId: string) =>
  `conversation_${conversationId}_chat_added`;
export const JOIN_BATCH_ROOM = (batchId: string) => `batch_${batchId}_room`;
export function BLOCK_OR_UNBLOCKED(conversationId: string, type: string | 'block' | 'unblock') {
  return type === 'block'
    ? `conversation_${conversationId}_block`
    : `conversation_${conversationId}_unblock`;
}
export function BLOCK_OR_UNBLOCKED_BATCH(batchId: string, type: string | 'block' | 'unblock') {
  return type === 'block' ? `batch_${batchId}_chat_block` : `batch_${batchId}_chat_unblock`;
}
export const joinPathshalaRoom = (scheduleId: string) => `pathshala_${scheduleId}_room`;
export const POLL_ROOM = (scheduleId: string) => `poll_${scheduleId}_room`;
export function CHAT_ENABLED(conversation_id: string) {
  return `conversation_${conversation_id}_enable`;
}
export function CHAT_DISABLED(conversation_id: string) {
  return `conversation_${conversation_id}_disable`;
}
export function CHAT_DELETED(conversationId: string) {
  return `conversation_${conversationId}_chat_delete`;
}
export function BATCH_CHAT_BLOCKED(batchId: string) {
  return `batch_${batchId}_chat_block`;
}
export function BATCH_CHAT_UNBLOCKED(batchId: string) {
  return `batch_${batchId}_chat_unblock`;
}
export function POLL_START(scheduleId: string) {
  return `poll_start_v2_${scheduleId}`;
}
export function POLL_EXPIRY(pollId: string) {
  return `poll_stop_expiry_v2_${pollId}`;
}
export function POLL_RESULT(pollId: string) {
  return `poll_result_v2_${pollId}`;
}
export function POLL_STOP(pollId: string) {
  return `poll_stop_v2_${pollId}`;
}
export function classReschedluedEvent(scheduleId: string) {
  return `schedule_${scheduleId}_rescheduled`;
}
export function joinScheduleRoom(scheduleId: string) {
  return `schedule_${scheduleId}_room`;
}
export function getChatMQTTTopic(conversationId: string) {
  return `chat/group/${conversationId}/inbox`;
}
export function getEmojiChatMQTTTopic(scheduleId: string) {
  return `emoji/${scheduleId}/schedule`;
}
export function getScheduleMQTTTopic(scheduleId: string) {
  return `schedule/${scheduleId}/info`;
}
export function getBatchMQTTTopic(batchId: string) {
  return `batch/${batchId}/info`;
}
// events for socket implementation in live chat
export const JOIN_EMOJI_ROOM = (scheduleId: string) => `schedule_${scheduleId}_emoji_room`;
export const RECEIVE_EMOJI = (scheduleId: string) => `schedule_${scheduleId}_receive_emoji`;
export const SEND_EMOJI = (scheduleId: string) => `schedule_${scheduleId}_send_emoji`;
export const TRENDING_EMOJI = (scheduleId: string) => `schedule_${scheduleId}_trending_emoji`;
export const UPDATE_TEMPLATE = (scheduleId: string) => `schedule_${scheduleId}_update_emoji`;
export const CONFIG_EMOJI = (scheduleId: string) => `schedule_${scheduleId}_config_emoji`;
